var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoverRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ed193a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-395 -2498)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(395 2498)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416 2528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.98,139.592h0L27.756,132.4a1.382,1.382,0,0,0-1.95,1.959l4.849,4.826H1.382a1.382,1.382,0,1,0,0,2.764H30.655l-4.849,4.826a1.382,1.382,0,0,0,1.95,1.959l7.222-7.188h0A1.383,1.383,0,0,0,34.98,139.592Z",
    transform: "translate(0 -132)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverRightArrow);
export default __webpack_public_path__ + "static/media/hover-right-arrow.3061f128e69a17ce8475a2922f1c1afd.svg";
export { ForwardRef as ReactComponent };